import { ReactElement } from "react";

import { cellDefaultCss } from "../Cells.style";

export interface CellProp {
  cell: Record<string, string>;
}

const Cell = ({ cell }: CellProp): ReactElement => {
  return <span css={cellDefaultCss}>{cell["value"] || "-"}</span>;
};

export default Cell;
